import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { usePublicConfig } from "@/api/queries/config";
import { usePageMeta } from "@/hooks/use-page-meta";
import { loadLegalContent } from "@/lib/legal-content";

export const Route = createFileRoute("/_public/agb")({
	component: AgbPage,
});

function AgbPage() {
	const { data: config } = usePublicConfig();
	const [html, setHtml] = useState("");

	usePageMeta({
		title: config?.seo.titles.agb,
		description: config?.seo.descriptions.agb || undefined,
	});

	useEffect(() => {
		loadLegalContent("agb").then(setHtml);
	}, []);

	return (
		<div className="max-w-3xl mx-auto">
			<div
				className="prose text-text-secondary [&_h1]:text-text [&_h2]:text-text"
				dangerouslySetInnerHTML={{ __html: html }}
			/>
		</div>
	);
}
